import React from "react";
import { DownloadButton, OverviewLayout } from "../../../components";
import {
  Alert,
  Box,
  Container,
  InputLabel,
  Stack,
  Typography,
} from "@mui/material";
import { NavigationBar } from "../../../components/General";
import AWS from "aws-sdk";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { useUploadRegistrationMutation } from "../../../store/uploadRegistration/uploadRegistrationApi";
import UploadRegistrationInput from "./UploadRegistrationInput";
import Swal from "sweetalert2";

AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_ACCESS_SECRET_KEY,
  region: "ap-south-1",
});

const breadcrumbs = [
  <Typography
    className="tw-text-[11px] tw-font-semibold tw-tracking-[1px] tw-leading-6 tw-font inter-font"
    key="100"
  >
    UPLOAD REGISTRATION
  </Typography>,
  <Typography
    className="tw-text-dark-blue tw-text-[11px] tw-font-semibold tw-tracking-[1px] tw-leading-6 tw-font inter-font"
    key="100"
  >
    UPLOAD DOCUMENT SENT BY COURIER
  </Typography>,
];

const UploadRegistrationByCourier = () => {
  const [uploadRegistration, { isLoading, isSuccess, isError }] =
    useUploadRegistrationMutation();

  const location = useLocation();
  const routingData = location.state;

  const initialState = {
    signedFileURL: null,
    courierFilerURL: null,
    deliveredFileURL: null,
    letterUploaded: false,
    courierUploaded: false,
    deliveryUploaded: false,
    alert: null,
  };

  const handleStateChange = (state, action) => {
    switch (action.type) {
      case "signedFileURL":
        return { ...state, signedFileURL: action.payload };
      case "courierFilerURL":
        return { ...state, courierFilerURL: action.payload };
      case "deliveredFileURL":
        return { ...state, deliveredFileURL: action.payload };
      case "letterUploaded":
        return { ...state, letterUploaded: !state.letterUploaded };
      case "courierUploaded":
        return { ...state, courierUploaded: !state.courierUploaded };
      case "deliveryUploaded":
        return { ...state, deliveryUploaded: !state.deliveryUploaded };
      case "alert":
        return { ...state, alert: action.payload };
      default:
        return state;
    }
  };

  const [state, dispatch] = React.useReducer(handleStateChange, initialState);

  const navigate = useNavigate();

  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
  } = useForm({
    mode: "onSubmit",
    criteriaMode: "firstError",
    reValidateMode: "onSubmit",
  });

  const {
    handleSubmit: handleSubmit2,
    register: register2,
    control: control2,
    formState: { errors: errors2 },
  } = useForm({
    mode: "onSubmit",
    criteriaMode: "firstError",
    reValidateMode: "onSubmit",
  });

  const {
    handleSubmit: handleSubmit3,
    register: register3,
    control: control3,
    formState: { errors: errors3 },
  } = useForm({
    mode: "onSubmit",
    criteriaMode: "firstError",
    reValidateMode: "onSubmit",
  });

  React.useEffect(() => {
    if (isSuccess) {
      dispatch({
        type: "alert",
        payload: null,
      });
      Swal.fire({
        title: "Uploaded",
        text: "Documents has been uploded",
        icon: "success",
        timer: 1500,
      });
      navigate("/home/upload");
    }
  }, [isSuccess]);

  React.useEffect(() => {
    if (isError) {
      dispatch({
        type: "alert",
        payload: {
          severity: "error",
          message: "Something went wrong. please try again",
        },
      });
    }
  }, [isError]);

  const onSubmitLetter = (data) => {
    try {
      const s3 = new AWS.S3();
      const params = {
        Bucket: process.env.REACT_APP_S3_BUCKET_NAME,
        Key: "registration file/" + data.letter[0].name,
        Body: data.letter[0],
        ContentType: "application/pdf",
      };
      s3.upload(params, (err, data) => {
        if (err) {
          console.log(err);
          dispatch({
            type: "alert",
            payload: {
              severity: "error",
              message: "Something went wrong. please try again",
            },
          });
        } else {
          console.log("File uploaded Successfully!", data);
          dispatch({
            type: "signedFileURL",
            payload: data?.Location,
          });
          dispatch({ type: "letterUploaded" });
        }
      });
    } catch (error) {
      console.log("Error uploading file:", error);
    }
  };

  const onSubmitCourier = (data) => {
    try {
      const s3 = new AWS.S3();
      const params = {
        Bucket: process.env.REACT_APP_S3_BUCKET_NAME,
        Key: "registration file/" + data.courier[0].name,
        Body: data.courier[0],
        ContentType: "application/pdf",
      };
      s3.upload(params, (err, data) => {
        if (err) {
          console.log(err);
          dispatch({
            type: "alert",
            payload: {
              severity: "error",
              message: "Something went wrong. please try again",
            },
          });
        } else {
          console.log("File uploaded Successfully!", data);
          dispatch({
            type: "courierFilerURL",
            payload: data?.Location,
          });
          dispatch({ type: "courierUploaded" });
        }
      });
    } catch (error) {
      console.log("Error uploading file:", error);
      window.alert("Error uploading file:", error);
    }
  };

  const onSubmitDelivery = (data) => {
    try {
      const s3 = new AWS.S3();
      const params = {
        Bucket: process.env.REACT_APP_S3_BUCKET_NAME,
        Key: "registration file/" + data.delivery[0].name,
        Body: data.delivery[0],
        ContentType: "application/pdf",
      };
      s3.upload(params, (err, data) => {
        if (err) {
          console.log(err);
          dispatch({
            type: "alert",
            payload: {
              severity: "error",
              message: "Something went wrong. please try again",
            },
          });
        } else {
          console.log("File uploaded Successfully!", data);
          dispatch({
            type: "deliveredFileURL",
            payload: data?.Location,
          });
          dispatch({ type: "deliveryUploaded" });
        }
      });
    } catch (error) {
      console.log("Error uploading file:", error);
      window.alert("Error uploading file:", error);
    }
  };

  const handleFinalUpload = async () => {
    if (!state.signedFileURL) {
      dispatch({
        type: "alert",
        payload: {
          severity: "error",
          message: "Please upload signed registration letter",
        },
      });
    } else if (!state.courierFilerURL) {
      console.log("dispatchin...2");
      dispatch({
        type: "alert",
        payload: {
          severity: "error",
          message: "Please upload courier reciept",
        },
      });
    } else {
      await uploadRegistration({
        region_id: routingData.region,
        location_id: routingData.location,
        sending_mode: routingData.mode,
        org_id: routingData.org_id,
        signed_registration_letter: state.signedFileURL,
        courier_reciept: state.courierFilerURL,
        delivery_confirmation: state.deliveredFileURL,
      });
    }
  };

  return (
    <OverviewLayout>
      <Container
        className="tw-p-20"
        sx={{
          height: "100vh",
          width: "100%",
          maxWidth: "1300px",
          margin: 0,
          display: "flex",
          flexDirection: "column",
          gap: "30px",
        }}
      >
        <NavigationBar breadcrumbs={breadcrumbs} />
        <Stack marginTop={4} rowGap={3} className="tw-pt-16">
          <Typography fontSize={"20px"} fontWeight={"600"}>
            Upload Registration Documents sent by courier
          </Typography>

          {state.alert && (
            <Box className="lg:tw-mr-20">
              <Alert
                severity={state.alert?.severity}
                onClose={() => {
                  dispatch({ type: "alert", payload: null });
                }}
              >
                {state.alert?.message}
              </Alert>
            </Box>
          )}

          <Box className="tw-mt-8 lg:tw-mr-20">
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              gap={2}
              alignItems={"flex-start"}
            >
              <InputLabel>Copy of the signed registration letter</InputLabel>
              <form onSubmit={handleSubmit(onSubmitLetter)}>
                <UploadRegistrationInput
                  register={register}
                  name={"letter"}
                  control={control}
                  success={state.letterUploaded}
                  error={errors?.letter?.message}
                  validations={{ required: "Required" }}
                />
              </form>
            </Stack>
          </Box>
          <Box className="tw-mt-8 lg:tw-mr-20">
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              gap={2}
              alignItems={"flex-start"}
            >
              <InputLabel>Copy of the reciept of the courier</InputLabel>
              <form onSubmit={handleSubmit2(onSubmitCourier)}>
                <UploadRegistrationInput
                  register={register2}
                  name={"courier"}
                  control={control2}
                  success={state.courierUploaded}
                  error={errors2?.courier?.message}
                  validations={{ required: "Required" }}
                />
              </form>
            </Stack>
          </Box>
          <Box className="tw-mt-8 lg:tw-mr-20">
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              gap={2}
              alignItems={"flex-start"}
            >
              <InputLabel>
                Copy of the delivery confirmation (Optional )
              </InputLabel>
              <form onSubmit={handleSubmit3(onSubmitDelivery)}>
                <UploadRegistrationInput
                  register={register3}
                  name={"delivery"}
                  control={control3}
                  success={state.deliveryUploaded}
                  error={errors3?.delivery?.message}
                  validations={{ required: "Required" }}
                />
              </form>
            </Stack>
          </Box>
          <Box display={"flex"} justifyContent={"center"} className="tw-mt-20">
            <DownloadButton
              label="Upload"
              loading={isLoading}
              onClick={handleFinalUpload}
            />
          </Box>
        </Stack>
      </Container>
    </OverviewLayout>
  );
};

export default UploadRegistrationByCourier;
